import React, { useState } from 'react';
import { Hero } from '../components/Hero';
import { TrustStrip } from '../components/TrustStrip';
import { Services } from '../components/Services';
import { EstimateBuilder } from '../components/EstimateBuilder';
import { BeforeAfter } from '../components/BeforeAfter';
import { ChecklistMagnet } from '../components/ChecklistMagnet';
import { Reviews } from '../components/Reviews';
import { About } from '../components/About';
import { FinalCta } from '../components/FinalCta';
import { OfferModal } from '../components/OfferModal';
export function Home() {
  const [selected, setSelected] = useState<string[]>([]);
  const toggleService = (id: string) => setSelected(prev => prev.includes(id) ? prev.filter(s => s !== id) : [...prev, id]);
  return <>
      <Hero data-id="element-493" data-mp="3kvac6mkbgbvj" />
      <TrustStrip data-id="element-494" data-mp="3kvtn3jbju002" />
      <Services selected={selected} onToggle={toggleService} data-id="element-495" data-mp="3ku8sjtp8ih27" />
      <EstimateBuilder selected={selected} onToggle={toggleService} data-id="element-496" data-mp="3owvpua4ocu6s" />
      <BeforeAfter data-id="element-497" data-mp="3oyyn9f85pplj" />
      <ChecklistMagnet data-id="element-498" data-mp="30wrp4gg89xfj" />
      <Reviews data-id="element-499" data-mp="30xb5vtu56frz" />
      <About data-id="element-500" data-mp="30vqeue71deyv" />
      <FinalCta data-id="element-501" data-mp="30w9lgyr8kgxl" />
      <OfferModal data-id="element-502" data-mp="30up1u46gmiei" />
    </>;
}